import Slider from '@mui/material/Slider'
import createMuiTheme, { Theme } from '@mui/material/styles/createTheme'
import ThemeProvider from '@mui/material/styles/ThemeProvider'

// TODO: Make the halo ring white when hovering over or clicking on the slider
// thumb.

const getSliderTheme = (color: string): Theme => {
  return createMuiTheme({
    components: {
      MuiSlider: {
        styleOverrides: {
          root: { height: 6, borderRadius: 0 },
          thumb: {
            color,
          },
          track: {
            color,
          },
          rail: {
            color: '#D9D9D9',
            opacity: 1,
          },
          mark: { display: 'none' },
        },
      },
    },
  })
}

const LABELS = [0, 2, 4, 6]

type HourSliderProps = React.PropsWithChildren<{
  color: string
  sessionText: string
  timeIntervalText: string
  value: number
  onSliderChange: (event: Event) => void
  disabled: boolean
}>

export const HourSlider = ({
  color,
  sessionText,
  timeIntervalText,
  children,
  value,
  onSliderChange,
  disabled,
}: HourSliderProps): JSX.Element => (
  <>
    {children}
    <div className='col-span-3 flex flex-col justify-between h-20 w-5/6'>
      <div className='flex justify-between items-baseline'>
        <p className='text-lg font-normal'>{sessionText}</p>
        <p className='text-sm font-light'>{timeIntervalText}</p>
      </div>
      <ThemeProvider theme={getSliderTheme(color)}>
        <Slider
          defaultValue={0}
          value={value}
          onChange={onSliderChange}
          step={0.5}
          min={0}
          max={6}
          valueLabelDisplay='auto'
          disabled={disabled}
        />
      </ThemeProvider>
      <div className='flex justify-between'>
        {LABELS.map((label) => (
          <p key={label} className='text-sm font-light text-body-black'>
            {label}hrs
          </p>
        ))}
      </div>
    </div>
  </>
)
